import React from 'react';
import { FileText, Download, Eye } from 'lucide-react';

export default function SupplyCard({ supply }) {
  // Determinar si usar URL de previsualización o descarga
  const isPreview = supply.previewUrl && !supply.fileUrl;
  const linkUrl = isPreview ? supply.previewUrl : supply.fileUrl;
  const buttonText = isPreview ? "Previsualizar" : "Descargar";
  const IconComponent = isPreview ? Eye : Download;
  const buttonBgClass = isPreview ? "bg-green-600 hover:bg-green-500" : "bg-blue-900 hover:bg-blue-800";

  return (
    <div className="flex justify-between items-center p-4 bg-white border border-blue-200 rounded-lg shadow hover:shadow-lg transition-shadow duration-200">
      <div className="flex items-center gap-4">
        <FileText className="h-6 w-6 text-blue-900" />
        <div>
          <h2 className="text-lg font-bold text-blue-800">{supply.title}</h2>
          <p className="text-sm text-blue-700">{supply.course}</p>
        </div>
      </div>
      <a
        href={linkUrl}
        download={!isPreview} // Solo añadir atributo download si no es previsualización
        target={isPreview ? "_blank" : undefined} // Abrir en nueva pestaña para previsualización
        rel={isPreview ? "noopener noreferrer" : undefined}
        className={`flex items-center gap-2 text-white text-sm px-4 py-2 rounded-lg shadow transition-colors ${buttonBgClass}`}
      >
        <IconComponent className="h-4 w-4" />
        {buttonText}
      </a>
    </div>
  );
}
